<template>
  <div class="jura-jobs">
    <b-container>
        <b-row class="section">
            <b-col>
              <h2>Jobs und Karriere</h2>
              <p>Wir suchen ab sofort einen ausgelernten Maler und Lackierer möglichst mit Berufserfahrung.<br>
              Sehr gute Kenntnisse im Trockenbau und in Verputzarbeiten erwünscht.</p>

              <h3>Sie arbeiten</h3>
              <ul>
                <li>selbständig, sauber und korrekt,</li>
                <li>können tapezieren,</li>
                <li>Wandlasuren und Spachteltechniken erstellen,</li>
                <li>kennen sich mit Wärmedammverbundsystemen aus,</li>
                <li>sowie mit Innen- und Außenputz und Gerüstbau,</li>
              </ul>

              <p>dann bewerben Sie sich bei uns.</p>

              <p>Senden Sie Ihre schriftliche Bewerbung an:
              <br><br>
              Malermeister<br>
              Rüdiger Jura<br>
              Malerfach- und Stuckateurbetrieb<br>
              Richard-Wagner-Str 13<br>
              66265 Heusweiler<br>
              <br>
              oder per e-Mail an: <a href="mailto:info@maler-jura.de">info@maler-jura.de</a><br>
              <br>
              Berwerbungsunterlagen:<br>
              <br>
              Lebenslauf, Kopie Gesellenbrief, Zeugnisse von Schulabschlüssen und ehemaligen Arbeitgebern.
              <br>
              Wir freuen uns auf Ihre Bewerbung.</p>

            </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'start',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.jura-jobs {
  padding: 40px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Jobs.vue